import { tv } from 'tailwind-variants'

export const topBar = tv({
  slots: {
    image: '-my-2 h-10 w-8 object-contain',
  },
})
